// @flow
import * as React from 'react';
import { connect } from 'react-redux';

import { FormattedMessage } from 'translations';
import { constants } from 'mz-sdk';
import Dropdown from 'mz-ui-kit/core/Dropdown';
import Button from 'mz-ui-kit/core/Button';

import * as searchResultsActions from 'app/actions/search-results';
import { ButtonSpacer, SortByLabel } from './elements';
import config from 'config';
import posthog from 'posthog-js';

const { SORTER_ENUM } = constants;

const messages = {
  sort_by: { id: 'SEARCH_RESULTS.SORT_BY' },
  [SORTER_ENUM.RECOMMENDED]: { id: 'SEARCH_RESULTS.SORT_BY_OPTIONS.RECOMMENDED' },
  [SORTER_ENUM.HIGH_PRICE]: { id: 'SEARCH_RESULTS.SORT_BY_OPTIONS.HIGHEST_PRICE' },
  [SORTER_ENUM.LOW_PRICE]: { id: 'SEARCH_RESULTS.SORT_BY_OPTIONS.LOWEST_PRICE' },
  [SORTER_ENUM.FASTEST]: { id: 'SEARCH_RESULTS.SORT_BY_OPTIONS.FASTEST' }
};

const optionTemplate = (sort) => <FormattedMessage {...messages[sort]} />

type Props = {
  activeSort?: $Keys<typeof SORTER_ENUM>,
  selectSortOption: Function
};

const sortOptions = Object.values(SORTER_ENUM);

const captureEvent = (value) => {
  posthog.capture('Results Sorted', {
    results_sort_type: value
  })
}

/**
 *
 * @param {String} activeSort
 * @param {Function} selectSortOption
 * @return Component
 *
 * Sort search results by different criteria
 */
function SortBy ({ activeSort = SORTER_ENUM.RECOMMENDED, selectSortOption }: Props) {
  const handleSelectSortOption = (value) => {
    selectSortOption(value);
    captureEvent(value);
  }

  return (
    config.SHOW_SORT_BUTTONS_IN_SRP &&
    <Dropdown
      options={sortOptions}
      onSelect={handleSelectSortOption}
      target={(innerRef, targetProps) => (
        <ButtonSpacer>
          <Button
            color='secondary'
            {...targetProps}
            innerRef={innerRef}>
              <SortByLabel>
                <FormattedMessage {...messages.sort_by} />
              </SortByLabel>
              <FormattedMessage {...messages[activeSort]} />
          </Button>
        </ButtonSpacer>
      )}
      renderOption={optionTemplate}
    />
  )
}

const mapStateToProps = state => ({
  activeSort: state.searchResults?.activeFilters?.sort
});

const mapDispatchToProps = {
  selectSortOption: searchResultsActions.selectSortOption
};

export default connect(mapStateToProps, mapDispatchToProps)(SortBy);
